module.exports = __webpack_public_path__ + "static/8-eac5564e509cb12ac6b191dd008211a8.mp4";